import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "picker-container" }

import { ConditionViewModel } from './models/conditionViewModel';
import { IConditionsManager } from './models/conditionsManager';
import { ConditionOperationType } from '@/shared/components/conditions/models/conditions';
import { PropType, ref, onMounted, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionConfigurator',
  props: {
  value: {
    type: Object as PropType<ConditionViewModel>,
    required: true,
  },
  manager: {
    type: Object as PropType<IConditionsManager>,
    required: true,
  },
},
  emits: ["updated", "completed"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const condition = ref<ConditionViewModel>({
  attribute: '',
  operation: '',
  type: '',
  unit: '',
  value: '',
  result: true,
});

onMounted(() => {
  if (props.value) {
    condition.value = {
      attribute: props.value.attribute,
      operation: props.value.operation,
      type: mappedType.value,
      unit: props.value.unit,
      value: props.value.value,
      result: props.value.result,
      invalid: props.value.invalid,
      isNew: props.value.isNew,
    };
  }
});

const mappedType = computed(() => {
  const mappings: { [key: string]: string } = {
    seconds: 'duration',
  };
  return mappings[props.value.type] != null ? mappings[props.value.type] : props.value.type;
});

const conditionConfigComponent = computed(() => {
  return props.manager.getConfigComponent(condition.value);
});

const conditionOptions = computed(() => {
  return props.manager.getConditionOptions(condition.value);
});

function conditionUpdated(update: ConditionViewModel) {
  // pass up any changes as they happen, so that the parent has the up-to-date state
  // if the config is closed by clicking away
  if (update.operation === ConditionOperationType.IsSet) {
    update.value = '';
    update.unit = undefined;
  }

  condition.value = update;
  emit('updated', condition.value);
}

function onConfigChanged(update: ConditionViewModel) {
  // let the parent know that the config has been closed by clicking the done button
  condition.value = update;
  emit('completed', condition.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(conditionConfigComponent.value), {
      condition: condition.value,
      options: conditionOptions.value,
      onChanged: conditionUpdated,
      onCompleted: onConfigChanged
    }, null, 40, ["condition", "options"]))
  ]))
}
}

})